import React from "react";
import Button from 'react-bootstrap/Button'

export interface TableHeaderProps {
    label: string
    preview?: boolean
    children?: React.ReactNode; 
}

export const TableHeader: React.FC<TableHeaderProps> = (props: React.PropsWithChildren<TableHeaderProps>) => {
    if (props.preview) {
        return <h4 className="mb-2">{props.label}</h4>
    }

    return <div className="table-header table-header d-flex justify-content-between pl-2">
        <h5 className="align-self-center">{props.label}</h5>
        <div>
            {props.children}
        </div>
    </div>;
}